import cx from 'classnames';
import { Icon } from 'components/Icon';

type Props = {
  amount: number;
  className: string;
};

export const GoalChange = ({ amount, className }: Props): JSX.Element => {
  const baseClassName = 'text-sm rounded-sm px-4 inline-flex items-center';

  if (amount > 0) {
    return (
      <span className={cx(baseClassName, className, 'bg-success-100 text-success-800')}>
        <Icon name="ArrowUp" className="inline-block w-8 mr-4" />
        {amount}%
      </span>
    );
  }

  if (amount < 0) {
    return (
      <span className={cx(baseClassName, className, 'bg-error-50 text-error-900')}>
        <Icon name="ArrowUp" className="inline-block w-8 mr-4 rotate-180" />
        {Math.abs(amount)}%
      </span>
    );
  }

  return (
    <span className={cx(baseClassName, className, 'bg-gray-100 text-gray-600')}>
      <Icon name="ArrowUp" className="inline-block w-8 mr-4" />
      {amount}%
    </span>
  );
};
